// extracted by mini-css-extract-plugin
module.exports = {"container":"work_container__2blFW","projects":"work_projects__23jn0"};